import store from '@/store';

const baseParams = {
    "mode": "FASTEST",
    "profile": "NORMAL",
    "resultOptions": {
        "includePolyline": true,
        "includePolylineWKT": true,
        "includeTurnByTurn": true,
    }
}

let routeSettings = {};

export const getRouteParams = (type, timeType = false, preparedSettings = false) => {
    let initialSettings = JSON.parse(JSON.stringify(store.getters.activeRouteSettings));  //clone data to be used as starting point for the changes
    routeSettings = initialSettings;

    // settings passed to function
    if(preparedSettings) {
        routeSettings = JSON.parse(JSON.stringify(preparedSettings))
    }

    let params = {
        ...baseParams,
        type,
        waypoints: store.getters.routeWaypoints,
        exclude: getExcludes(type),
    }

    const routeTimes = getRouteTime(timeType);
    if(routeTimes) {
        params = {...params, ...routeTimes};
    }

    if(type === 'PUBLIC') {
        params.waypoints = [
            store.getters.routeWaypoints[0],
            store.getters.routeWaypoints[store.getters.routeWaypoints.length - 1],
        ];
        params.publicTransportationParameters = params.publicTransportationParameters === undefined ? getPublicModeOptions() : {...params.publicTransportationParameters, ...getPublicModeOptions()}
    }

    if(type === 'BIKE') {
        params.bikeParameters = getBikeParameters()
    }

    const mode = getTravelMode(type)
    if(mode) {
        params.mode = mode
    }

    return params;
}

function getExcludes(type) {
    let excludes = {}
    const typeKey = type.toLowerCase()
    if(!routeSettings[typeKey]) return {}

    if(routeSettings[typeKey].avoid) {
        excludes = routeSettings[typeKey].avoid
    }

    // avoid tunnels
    if(routeSettings[typeKey] && routeSettings[typeKey].avoidTunnels && routeSettings[typeKey].avoidTunnels !== '') {
        excludes.maxTunnelLength = parseInt(routeSettings[typeKey].avoidTunnels)
    }

    // avoid countries
    if(routeSettings[typeKey] && routeSettings[typeKey].avoidCountries && routeSettings[typeKey].avoidCountries.length > 0) {
        excludes.countries = routeSettings[typeKey].avoidCountries
    }

    return excludes;
}

function getPublicModeOptions() {
    let publicModeOptions = {
        meansOfTransport: getMeansOfTransport(),
        avoidBarriers: getAvoidBarriers(),
    };

    let maxChanges = getMaxChanges();
    if(maxChanges !== -1) {
        publicModeOptions.maxChanges = maxChanges;
    }

    let bikeCarriage = getBikeCarriage();
    if(bikeCarriage) {
        publicModeOptions.bikeCarriage = bikeCarriage;
    }

    return publicModeOptions;
}

function getMeansOfTransport() {
    let means = routeSettings.public.meansOfTransport;
    if(means.includes('TRAIN')) {
        means.push('URBAN_RAILWAY','CITY_RAILWAY','CAR_TRAIN');
    }
    return means;
}

function getRouteTime(timeType = false) {
    let times = {}
    let routeTime = store.getters.routeTrafficTime;
    if(store.getters.savedRouteTime) routeTime = store.getters.savedRouteTime
    if(routeTime.isNow && routeTime.mode !== 'arrival' && !timeType) {
        return false;
    }
    let mode = routeTime.mode === 'departure' || !routeTime.mode ? 'startTime' : 'arrivalTime';
    
    if(!routeTime.date) {
        times[mode] = new Date()
    } else {
        const splitTime = routeTime.time.split(':')
        times[mode] = new Date(routeTime.date)
        times[mode].setHours(splitTime[0], splitTime[1])
    }
    // time to get first and last connection for public mode
    if (timeType) {
        if (timeType === 'FIRST') {
            // departure: 4:00 on the current date
            times[mode].setHours(4, 0);
        } else if (timeType === 'LAST') {
           // arrival: 3:50 on the next day
            times.arrivalTime = new Date();
            times.arrivalTime.setDate(times[mode].getDate() + 1);
            times.arrivalTime.setHours(3, 50);
            delete times[mode]; 
        } else if (timeType === 'EARLIER') {
            times.publicTransportationParameters = {
                scrollInformation: {
                    earlierConnectionsHint: store.getters.transportModes['PUBLIC'].scrollInformation.earlierConnectionsHint
                }
            }
        } else if (timeType === 'LATER') {
            times.publicTransportationParameters = {
                scrollInformation: {
                    laterConnectionsHint: store.getters.transportModes['PUBLIC'].scrollInformation.laterConnectionsHint
                }
            }
        }
    }
    return times
}

function getAvoidBarriers() {
    return routeSettings.public.avoidBarriers;
}

function getBikeCarriage() {
    return routeSettings.public.other.bikeCarriage;
}

function getMaxChanges() {
    return parseInt(routeSettings.public.maxChanges);
}

function getTravelMode(type) {
    const typeKey = type.toLowerCase()
    if(routeSettings[typeKey] && routeSettings[typeKey].travelMode) {
        return routeSettings[typeKey].travelMode
    }
    return false
}

function getBikeParameters() {
    return routeSettings.bike.bikeParameters
}

export function getSharingModes() {
    let sharingRouteSettings = routeSettings.sharing
    // url query settings need to be checked here as it happens before the request are created
    if(store.getters.queryRouteSettings && store.getters.queryRouteSettings.sharing) {
        const defaultRouteOptions = JSON.parse(JSON.stringify(store.getters.routeSettings))
        const routeOptions = JSON.parse(JSON.stringify(store.getters.queryRouteSettings))
        const mergedRouteOptions = {...defaultRouteOptions, ...routeOptions}
        sharingRouteSettings = mergedRouteOptions.sharing
        // store.commit('setQueryRouteSettings', false)
    }
    return [...sharingRouteSettings.noLicence, ...sharingRouteSettings.licence]
}